import { FormFieldType } from "@/types/FormFieldsType"


const generateRegisterInputs = () => {
    return [
        {
            type: FormFieldType.TEXT,
            placeholder: "First Name",
            name: "first_name",
            required: true,
            valueAsNumber: false,
            label: "First Name"
        },
        {
            type: FormFieldType.TEXT,
            placeholder: "Last Name",
            name: "last_name",
            required: true,
            valueAsNumber: false,
            label: "Last Name"
        },
        {
            type: FormFieldType.TEXT,
            placeholder: "Email",
            name: "email",
            required: true,
            valueAsNumber: false,
            label: "Email"
        },
        {
            type: FormFieldType.PASSWORD,
            placeholder: "Password",
            name: "password",
            required: true,
            valueAsNumber: false,
            label: "Password"
        },
        // {
        //     type: FormFieldType.CHECKBOX,
        //     placeholder: "I agree to the terms and conditions",
        //     name: "terms",
        //     required: true,
        //     valueAsNumber: false,
        //     label: "I agree to the terms and conditions"
        // }
    ]
}

const generateProfileInputs = () => {
    return [
        {
            type: FormFieldType.TEXT,
            placeholder: "First Name",
            name: "first_name",
            required: true,
            valueAsNumber: false,
            label: "First Name"
        },
        {
            type: FormFieldType.TEXT,
            placeholder: "Last Name",
            name: "last_name",
            required: true,
            valueAsNumber: false,
            label: "Last Name"
        },
        {
            type: FormFieldType.TEXT,
            placeholder: "Email",
            name: "email",
            required: true,
            valueAsNumber: false,
            label: "Email"
        }
    ]
}

const generateChangePasswordInputs = () => {
    return [
        {
            type: FormFieldType.PASSWORD,
            placeholder: "Old Password",
            name: "old_password",
            required: true,
            valueAsNumber: false,
            label: "Old Password"
        },
        {
            type: FormFieldType.PASSWORD,
            placeholder: "New Password",
            name: "new_password",
            required: true,
            valueAsNumber: false,
            label: "New Password"
        },
        {
            type: FormFieldType.PASSWORD,
            placeholder: "Confirm Password",
            name: "confirm_password",
            required: true,
            valueAsNumber: false,
            label: "Confirm Password"
        }
    ]
}

const generateLoginInputs = () => {
    return [
        {
            type: FormFieldType.TEXT,
            placeholder: "Email",
            name: "email",
            required: true,
            valueAsNumber: false,
            label: "Email"
        },
        {
            type: FormFieldType.PASSWORD,
            placeholder: "Password",
            name: "password",
            required: true,
            valueAsNumber: false,
            label: "Password"
        }
    ]
}

export {
    generateLoginInputs,
    generateProfileInputs,
    generateRegisterInputs,
    generateChangePasswordInputs
}